$(document).ready(function () {
  function getStorefrontData(query) {
    return fetch('https://eu.gtplayer.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'ce6a5fca1541006f3f0e8423dd1cf4be',
      },
      body: JSON.stringify({ query }),
    })
    .then(response => response.json())
    .then(data => data.data.node)
    .catch(error => {
      console.log("Product stacking images data fetch error")
      console.error(error)
    });
  }

  function getMetafieldQuery(variantId) {
    return `
      {
        node(id: "gid://shopify/ProductVariant/${variantId}") {
          ... on ProductVariant {
            metafield(key: "stack_preview_image", namespace: "custom") {
              value
            }
          }
        }
      }
    `
  }

  function getMediaImageQuery(globalImageId) {
    return `
      {
        node(id: "${globalImageId}") {
          ... on MediaImage {
            image {
              src
            }
          }
        }
      }
    `
  }

  function getElementZIndex(productHandle) {
    const lowCaseProductHandle = productHandle.toLowerCase();
    const baseIndex = 3;

    const indexFromName = lowCaseProductHandle.split('-index ');

    if (indexFromName[1]) {
      return indexFromName[1]
    }

    return baseIndex

    // if (lowCaseProductHandle.includes('index2')) {
    //   return baseIndex;
    // }

    // if (lowCaseProductHandle.includes('desk')) {
    //   return baseIndex;
    // }

    // if (lowCaseProductHandle.includes('index3')) {
    //   return baseIndex + 1;
    // }

    // if (lowCaseProductHandle.includes('index4')) {
    //   return baseIndex + 2;
    // }

    // if (lowCaseProductHandle.includes('index5')) {
    //   return baseIndex + 3;
    // }

    // if (lowCaseProductHandle.includes('chair')) {
    //   return baseIndex + 3;
    // }

    // if (lowCaseProductHandle.includes('index6')) {
    //   return baseIndex + 4;
    // }

    // if (lowCaseProductHandle.includes('index7')) {
    //   return baseIndex + 5;
    // }

    // if (lowCaseProductHandle.includes('index8')) {
    //   return baseIndex + 6;
    // }

    // if (lowCaseProductHandle.includes('index9')) {
    //   return baseIndex + 7;
    // }

    // console.log(productHandle)
    return baseIndex - 1;
  }

  const productSku = document.getElementById("pr_sku_ppr");
  // Options for the observer (which mutations to observe)
  const config = { childList: true };

  // Callback function to execute when mutations are observed
  const handleSkuChange = async (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        const variantHandle = document.querySelector('#pr_sku_ppr').textContent;
        const productVariant = mu_product.variants.find(variant => variant.sku === variantHandle);

        const productDataQuery = getMetafieldQuery(productVariant.id);
        const productData = await getStorefrontData(productDataQuery);

        if (!productData.metafield) {
          console.log("no stack_preview_image metafield for product")
          return;
        }

        const productMediaImageQuery = getMediaImageQuery(productData.metafield.value);
        const productMediaImage = await getStorefrontData(productMediaImageQuery);

        const productImg = document.createElement('div');
        productImg.classList.add('pdp-stack-image')
        productImg.style.backgroundImage = `url(${productMediaImage.image.src})`;
        productImg.setAttribute('data-variant-id', productVariant.id);
        productImg.setAttribute('data-field-name', variantHandle);
        productImg.setAttribute('data-product-type', 'chair');
        productImg.style.zIndex = getElementZIndex('chair');
        const pdpStack = document.querySelector('.pdp-stack__wrapper .pdp-stack');
        const chairImg = pdpStack ? pdpStack.querySelector(`[data-product-type="chair"]`) : null;
        if (chairImg) {
          chairImg.remove();
        }

        if (pdpStack) {
          pdpStack.appendChild(productImg)
        }

        const selectedVariant = document.querySelector('.swatch_pr_item.is-selected .swatch__value_pr');
        const computedStyle = window.getComputedStyle(selectedVariant);
        document.querySelector('.pdp-stack-preview').style.backgroundImage = computedStyle.backgroundImage;
      } else if (mutation.type === "attributes") {
        console.log(`The ${mutation.attributeName} attribute was modified.`);
      }
    }
  };

  // Create an observer instance linked to the callback function
  const skuObserver = new MutationObserver(handleSkuChange);
  // Start observing the target node for configured mutations
  skuObserver.observe(productSku, config);


  setTimeout(() => {
    // Select the node that will be observed for mutations
    const targetNode = document.querySelector('.gpo-hidden-inputs');
    const pdpStackEle = document.createElement('div');
    pdpStackEle.classList.add('pdp-stack');

    console.log(targetNode);
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = async (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          console.log("A child node has been added or removed.");
        } else if (mutation.type === "attributes") {
          if (mutation.attributeName === 'gpo-data-variant-id') {
            const variantHandle = document.querySelector('#pr_sku_ppr').textContent;
            const productVariant = mu_product.variants.find(variant => variant.sku === variantHandle);

            const addOnVariantId = mutation.target.getAttribute('gpo-data-variant-id');
            const addOnFieldName = mutation.target.getAttribute('data-field-name');
            // console.log(mutation.target)

            if (addOnVariantId) {
              const wrapper = document.querySelector('.pdp-stack__wrapper');
              let pdpStack = wrapper.querySelector('.pdp-stack');

              if (!pdpStack) {
                pdpStack = wrapper.appendChild(pdpStackEle);
              }

              const removeEles = wrapper.querySelectorAll(`[data-field-name="${addOnFieldName}"]`);
              removeEles.forEach(ele => ele.remove());

              if (addOnVariantId.includes(',')) {
                const addOnVariantIds = addOnVariantId.split(',');
                for (const addOnVariantId of addOnVariantIds) {
                  const addOnDataQuery = getMetafieldQuery(addOnVariantId);
                  const addOnData = await getStorefrontData(addOnDataQuery);

                  if (!addOnData.metafield) {
                    console.log(`no stack_preview_image metafield for addon ${addOnVariantId}`)
                    return;
                  }

                  const mediaImageQuery = getMediaImageQuery(addOnData.metafield.value);
                  const mediaImage = await getStorefrontData(mediaImageQuery);

                  const imgEle = document.createElement('div');
                  imgEle.classList.add('pdp-stack-image')
                  imgEle.style.backgroundImage = `url(${mediaImage.image.src})`;
                  imgEle.setAttribute('data-variant-id', addOnVariantId);
                  imgEle.setAttribute('data-field-name', addOnFieldName);
                  imgEle.style.zIndex = getElementZIndex(addOnFieldName);

                  if (!pdpStack.querySelector(`[data-variant-id="${addOnVariantId}"]`)) {
                    pdpStack.appendChild(imgEle)
                  }
                }
              } else {
                const addOnDataQuery = getMetafieldQuery(addOnVariantId);
                const addOnData = await getStorefrontData(addOnDataQuery);

                if (!addOnData.metafield) {
                  console.log(`no stack_preview_image metafield for addon ${addOnVariantId}`)
                  return;
                }

                const mediaImageQuery = getMediaImageQuery(addOnData.metafield.value);
                const mediaImage = await getStorefrontData(mediaImageQuery);

                const imgEle = document.createElement('div');
                imgEle.classList.add('pdp-stack-image')
                imgEle.style.backgroundImage = `url(${mediaImage.image.src})`;
                imgEle.setAttribute('data-variant-id', addOnVariantId);
                imgEle.setAttribute('data-field-name', addOnFieldName);
                imgEle.style.zIndex = getElementZIndex(addOnFieldName);

                if (!pdpStack.querySelector(`[data-variant-id="${addOnVariantId}"]`)) {
                  pdpStack.appendChild(imgEle)
                }
              }

              const productDataQuery = getMetafieldQuery(productVariant.id);
              const productData = await getStorefrontData(productDataQuery);

              if (!productData.metafield) {
                console.log("no stack_preview_image metafield for product")
                return;
              }

              const productMediaImageQuery = getMediaImageQuery(productData.metafield.value);
              const productMediaImage = await getStorefrontData(productMediaImageQuery);

              if (productMediaImage) {
                const productImg = document.createElement('div');
                productImg.classList.add('pdp-stack-image')
                productImg.style.backgroundImage = `url(${productMediaImage.image.src})`;
                productImg.setAttribute('data-variant-id', productVariant.id);
                productImg.setAttribute('data-field-name', variantHandle);
                productImg.setAttribute('data-product-type', 'chair');
                productImg.style.zIndex = getElementZIndex('chair');

                if (!pdpStack.querySelector(`[data-product-type="chair"]`)) {
                  const pdpStack = wrapper.querySelector('.pdp-stack');
                  pdpStack.appendChild(productImg)
                }
              }
            } else {
              const wrapper = document.querySelector('.pdp-stack__wrapper');
              const pdpStack = wrapper.querySelector('.pdp-stack');

              const removeEles = wrapper.querySelectorAll(`[data-field-name="${addOnFieldName}"]`);
              removeEles.forEach(ele => ele.remove())

              if (pdpStack && pdpStack.childElementCount === 1 && pdpStack.firstChild.getAttribute('data-product-type') === 'chair') {
                pdpStack.remove();
              }
              if (wrapper.childElementCount === 0) {
                pdpStack.remove();
              }
            }
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }, 4000);

  function setupPreviewWrapper() {
    const prGalleryEle = document.querySelector('.sp-pr-gallery');

    const stackWrapper = document.createElement('div');
    stackWrapper.classList.add('pdp-stack__wrapper');
    prGalleryEle.appendChild(stackWrapper);
  }

  function initStickyPreview() {
    const headerEle = document.querySelector('.ntheader_wrapper');

    const previewWrapperEle = document.createElement('div');
    previewWrapperEle.classList.add('pdp-stack-preview__wrapper');

    const previewEle = document.createElement('div');
    previewEle.classList.add('pdp-stack-preview');
    previewWrapperEle.appendChild(previewEle);

    const priceRangeWrapperEle = document.createElement('div');
    priceRangeWrapperEle.classList.add('price-range__wrapper');
    previewWrapperEle.appendChild(priceRangeWrapperEle);

    const titleEle = document.createElement('h4');
    titleEle.classList.add('title');
    priceRangeWrapperEle.appendChild(titleEle);

    const reviewEle = document.createElement('div');
    reviewEle.classList.add('review');
    priceRangeWrapperEle.appendChild(reviewEle);

    const priceRangeEle = document.createElement('div');
    priceRangeEle.classList.add('price-range');
    priceRangeWrapperEle.appendChild(priceRangeEle);

    headerEle.appendChild(previewWrapperEle);
  }

  function setPDPStackPreviewSync() {
    const priceRangeWrapperEle = document.querySelector('.pdp-stack-preview__wrapper .price-range__wrapper');
    const title = document.querySelector('.product_title');
    const productShortName = title.getAttribute('data-short-name');
    priceRangeWrapperEle.querySelector('.title').innerHTML = productShortName ? productShortName : title.innerHTML;

    const reviewObserver = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const review = document.querySelector('.product-widget__ryviu');
          if (review) {
            priceRangeWrapperEle.querySelector('.review').innerHTML = review.innerHTML;
          }
        }
      }
    });
    reviewObserver.observe(document.querySelector('.review-widget'), { attributes: true, childList: true, subtree: true });

    // Select the node that will be observed for mutations
    const targetNode = document.querySelector(".pdp-stack__wrapper");

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const previewEle = document.querySelector('.pdp-stack-preview');
          const node = targetNode;
          const clone = node ? node.cloneNode(true) : null;
          previewEle.innerHTML = clone.innerHTML;

          const gpoPrice = document.querySelector('.gpo-total-text');

          const title = document.querySelector('.product_title');
          const priceRangeWrapperEle = document.querySelector('.pdp-stack-preview__wrapper .price-range__wrapper');
          const totalText = document.createElement('div');
          totalText.classList.add('total-text');

          if (priceRangeWrapperEle.querySelector('.total-text')) {
            if (previewEle.childElementCount > 0) {
              priceRangeWrapperEle.querySelector('.total-text').innerHTML = gpoPrice.innerHTML;

              const productShortName = title.getAttribute('data-short-name');
              priceRangeWrapperEle.querySelector('.title').innerHTML = productShortName ? productShortName : title.innerHTML;
            } else {
              priceRangeWrapperEle.querySelector('.total-text').innerHTML = '';
            }
          } else {
            priceRangeWrapperEle.appendChild(totalText);
          }

        } else if (mutation.type === "attributes") {
          console.log(`The ${mutation.attributeName} attribute was modified.`);
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    const previewEle = document.querySelector('.pdp-stack-preview__wrapper');
    const toggleClass = "is-sticky";
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 500) {
        previewEle.classList.add(toggleClass);
      } else {
        previewEle.classList.remove(toggleClass);
      }
    });
  }

  function setUpPriceSync() {
    const priceRange = document.querySelector('#price_ppr');
    const priceRangeEle = document.querySelector('.pdp-stack-preview__wrapper .price-range');
    priceRangeEle.innerHTML = priceRange.innerHTML.replace('id="off_nav"', '');

    function handlePriceRangeChange(mutationList, observer) {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const priceRange = document.querySelector('#price_ppr');
          const priceRangeEle = document.querySelector('.pdp-stack-preview__wrapper .price-range');
          priceRangeEle.innerHTML = priceRange.innerHTML.replace('id="off_nav"', '');
        } else if (mutation.type === "attributes") {
          console.log(`The ${mutation.attributeName} attribute was modified.`);
        }
      }
    }

    const config = { childList: true, subtree: true };
    const priceRangeObserver = new MutationObserver(handlePriceRangeChange);
    priceRangeObserver.observe(priceRange, config);
  }

  setupPreviewWrapper();
  initStickyPreview();
  setPDPStackPreviewSync();
  setUpPriceSync();
});
